
export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Do I need any experience or artistic skill?',
    answer:
      'No. The flower does the beautiful part. Your job is to choose it, use the right method for it and respect the drying time. The 10 projects go from simplest to most detailed, so you can start with a bookmark and work up to a framed herbarium whenever you feel ready.',
  },
  {
    question: 'How long does it take to see results?',
    answer:
      'It depends on the flower and the method. Some methods leave a flower ready in a few hours, others need one to three weeks of drying. The guide gives you the estimated time for each one so you can plan around what you want to make, plus how to check on progress without ruining the piece.',
  },
  {
    question: 'Can I use this to sell what I make, not just as a hobby?',
    answer:
      'Yes. Several projects are designed for exactly that: pieces that look high-end but cost very little in materials, plus the seasonal calendar to gather blooms in time, the tracker sheets to work on several pieces at once, and the flower meaning guide to build collections with a real story behind them.',
  },
  {
    question: 'Is this a physical product? How do I get the files?',
    answer:
      'It is 100% digital. You get a 50+ page PDF guide with all 4 bonuses included, delivered by email the moment your payment goes through. Read it on your phone, tablet or computer, and print the herbarium and tracker sheets whenever you need them.',
  },
]
